import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  langData: any = [];
  constructor(private _http: HttpClient,
    private helper: HelperService
    ) { }

  // set and load language file
  translate(langVal: string = '') {
    return new Promise<{}>((resolve, reject) => {
      let activeLang = this.helper.getLocalStore('langVal');
      this._http.get('assets/i18n/'+(langVal ? langVal : activeLang ? activeLang : 'eng')+'.json').subscribe((data) => {
        this.helper.setLocalStore('langVal', langVal ? langVal : activeLang ? activeLang : 'eng')
        this.langData = data;
        // this._http.get('assets/i18n/extra.json').subscribe((data) => {});
        resolve(true)
      })
    });
  }

  fnTransform(key: string) {
    return this.langData[key?.toUpperCase()] || key;
  }
}
